var dialog = document.getElementById("popUp");
var overlay = document.getElementById("overlayContainer");
var body = document.body;
var scrollPosition = 0;
var main = document.querySelector(".body_apolo");

function openDialog(element) {
    var productId = element.getAttribute("product_id");
    var sectionId = element.getAttribute("data-section-id");
    var optionsDiv = document.querySelector(`.options_movil_${productId}`);
    if (!optionsDiv) {
      // fallback try with section
      optionsDiv = document.querySelector(`.options_movil_${productId}`);
    }
    if (optionsDiv) {
        var infoDinamica = optionsDiv.innerHTML;
        var popupContent = document.getElementById("popupContent");
        if(popupContent) {
          popupContent.innerHTML = infoDinamica;
          var selColor = element.getAttribute("data-selected-color") || optionsDiv.getAttribute("data-selected-color");
          if(selColor) popupContent.dataset.selectedColor = selColor;
        }
        scrollPosition = window.pageYOffset;
        body.style.top = `-${scrollPosition}px`;
        body.classList.add("noscroll");
        if(overlay) overlay.classList.add("overlayActive");
        if(dialog) dialog.classList.add("popUpActive");
    }
}
function closeDialog() {
    body.classList.remove("noscroll");
    if(overlay) overlay.classList.remove("overlayActive");
    if(dialog) dialog.classList.remove("popUpActive");
    body.style.top = '';
    window.scrollTo(0, scrollPosition);
}
if(overlay){
  overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
          closeDialog();
      }
  });
}
if(main){
    main.addEventListener("click", function (event) {
        var button_options = event.target.closest('.button_options');
        if (button_options) {
          // no seleccionar si es sold_out/disabled
          if(button_options.classList.contains('sold_out') || button_options.hasAttribute('disabled') || button_options.getAttribute('aria-disabled')==='true'){
            event.preventDefault();
            return;
          }
          handleSizeButtonClick(event, button_options);
        }
        var productLink = event.target.closest('.product-link');
        if (productLink) {
            event.preventDefault();
            const parentElement = productLink.parentNode;
            parentElement.querySelectorAll('a').forEach(e => { e.classList.remove('active'); });
            parentElement.querySelectorAll('a div').forEach(a => { a.classList.remove('disabled_tacha'); a.classList.remove('active'); });
            productLink.classList.add('active');
            var html_options = productLink.getAttribute('html_options');
            // Modelo anterior (productos relacionados): usa los blobs html_options
            if(html_options){
              var imgUrl = productLink.getAttribute('img_url');
              var product_id = productLink.getAttribute('product_id');
              var product_url = productLink.getAttribute('product_url');
              var section_id = productLink.getAttribute('section_id');
              var precio_original = productLink.getAttribute('price_original');
              var precio_oferta = productLink.getAttribute('price_sale');
              var selected_color = productLink.getAttribute('data-color-value') || productLink.getAttribute('color') || null;
              var variant_id_apolo = productLink.getAttribute('variant_id_apolo');
              var divsMain_price = document.querySelectorAll('.price_' + product_id + '_' + section_id);
              divsMain_price.forEach(function (divMain_price) {
                  var price_sale = divMain_price.querySelector('.price-item--sale');
                  var price_regular = divMain_price.querySelector('.apolo_regular');
                  var title = divMain_price.querySelector('.title_apolo');
                  if(title) title.setAttribute('href', product_url);
                  if (precio_original && price_regular) price_regular.textContent = precio_original;
                  if (precio_oferta && price_sale) price_sale.textContent = precio_oferta;
              });
              var divsMain = document.querySelectorAll('.apolo_' + product_id + '_' + section_id);
              divsMain.forEach(function (divMain) {
                  var container_options = divMain.querySelector('.container_options');
                  var btn_add_to_cart = divMain.querySelector('.btn_add_to_cart');
                  var icon_bag_apolo = divMain.querySelector('.icon_bag_apolo');
                  if(selected_color) divMain.dataset.selectedColor = selected_color;
                  if(container_options){
                    if(container_options.dataset) container_options.dataset.selectedColor = selected_color || '';
                    container_options.innerHTML = '';
                    container_options.innerHTML = html_options;
                  }
                  const imageMain = divMain.querySelector('img');
                  divMain.setAttribute('data-product-url', product_url);
                  if(icon_bag_apolo) {
                    icon_bag_apolo.setAttribute('product_id', variant_id_apolo);
                    if(section_id) icon_bag_apolo.setAttribute('data-section-id', section_id);
                    if(selected_color) icon_bag_apolo.setAttribute('data-selected-color', selected_color);
                  }
                  if(btn_add_to_cart) {
                    btn_add_to_cart.setAttribute('data-product-id', product_id);
                    if(selected_color) btn_add_to_cart.setAttribute('data-color', selected_color);
                  }
                  if(imageMain && imgUrl) imageMain.srcset = imgUrl;
              });
            } else {
              // Modelo nuevo (variantes Color+Talla): todo se deriva del JSON variants-data
              var newColor = productLink.getAttribute('data-color-value');
              var newPid = productLink.getAttribute('data-product-id');
              var newSid = productLink.getAttribute('data-section-id');
              if(newColor && newPid) updateCardForColor(newPid, newSid, newColor);
            }
        }
        var card = event.target.closest('[data-product-url]');
        if (card && !event.target.closest('.button_options') && !event.target.closest('.product-link') && !event.target.closest('.btn_add_to_cart') && !event.target.closest('.movil_options') ) {
            redirectToProduct(card);
        }
        var button = event.target.closest('.btn_add_to_cart');
        if (button) {
            event.preventDefault();
            var productId = button.getAttribute('data-product-id');
            var sectionId = button.getAttribute('data-section-id');
            if (productId) {
                addToCart(productId, sectionId, button);
            } else {
                console.error('No se encontró data-product-id');
            }
        }
        var svgIcon = event.target.closest('.icon_bag_apolo');
        if (svgIcon) {
            event.preventDefault();
            openDialog(svgIcon);
        }
    });
}
    function redirectToProduct(cardElement) {
        var productUrl = cardElement.getAttribute('data-product-url');
        if (productUrl) {
            window.location.href = productUrl;
        } else {
            console.error("No se encontró una URL válida en el card.");
        }
    }
    function handleSizeButtonClick(event, button) {
        event.stopPropagation();
        // scope por card, no global
        var card = button.closest('.card-wrapper') || button.closest('.apolo_card') || button.closest('.product-card-wrapper');
        if(!card) card = document;
        // remover selected solo dentro de esta card
        var scope = card !== document ? card : button.closest('.flex_options') || document;
        // si está dentro de card, quitar solo de esa card
        if(card && card.querySelectorAll){
          card.querySelectorAll(".btn_apolo").forEach(function (btn) { btn.classList.remove("selected"); });
        } else {
          document.querySelectorAll(".btn_apolo").forEach(function (btn) { btn.classList.remove("selected"); });
        }
        button.classList.add("selected");
    }

    function getCardVariants(productId, sectionId){
      var jel = null;
      if(sectionId) jel = document.querySelector(`.variants-data[data-product-id="${productId}"][data-section-id="${sectionId}"]`);
      if(!jel) jel = document.querySelector(`.variants-data[data-product-id="${productId}"]`);
      if(!jel) return [];
      try{ return JSON.parse(jel.textContent) || []; }catch(e){ return []; }
    }
    function formatSoles(cents){
      var n = (parseInt(cents||0,10)/100).toFixed(2);
      if(window.Shopify && Shopify.formatMoney){ try{ return Shopify.formatMoney(parseInt(cents||0,10), 'S/ {{amount}}'); }catch(e){} }
      return 'S/ ' + n;
    }
    function updateCardForColor(productId, sectionId, colorValue){
      var sel = sectionId ? `.apolo_${productId}_${sectionId}` : null;
      var cards = sel ? document.querySelectorAll(sel) : document.querySelectorAll(`[data-product-id="${productId}"]`);
      // fallback: buscar por variants-data
      if(!cards.length){
        var jel = document.querySelector(`.variants-data[data-product-id="${productId}"]`);
        var wrap = jel ? jel.closest('.card-wrapper') : null;
        cards = wrap ? [wrap] : [];
      }
      var variants = getCardVariants(productId, sectionId);
      if(!variants.length) return;
      var colorVars = variants.filter(function(v){ var o=v.options||[v.option1,v.option2,v.option3]; return o.includes(colorValue); });
      if(!colorVars.length) return;
      var firstAvail = colorVars.find(function(v){ return v.available; }) || colorVars[0];
      // tallas únicas del color (las opciones que no son el color)
      var sizes = [];
      colorVars.forEach(function(v){
        var o=v.options||[v.option1,v.option2,v.option3];
        o.forEach(function(op){ if(op!==colorValue && !sizes.includes(op)) sizes.push(op); });
      });
      cards.forEach(function(card){
        card.dataset.selectedColor = colorValue;
        var container = card.querySelector('.container_options');
        if(container){
          if(container.dataset) container.dataset.selectedColor = colorValue;
          var flex = container.querySelector('.flex_options');
          if(flex && sizes.length){
            flex.innerHTML = sizes.map(function(s){
              var vv = colorVars.find(function(v){ var o=v.options||[v.option1,v.option2,v.option3]; return o.includes(s); });
              var avail = vv && vv.available;
              return `<button type="button" data-variant-size="${s}" data-color="${colorValue}" data-section-id="${sectionId||''}" class="${avail?'':'sold_out '}btn_apolo relative button_options" ${avail?'':'disabled aria-disabled="true"'}>${s}</button>`;
            }).join('');
          }
        }
        var btn = card.querySelector('.btn_add_to_cart');
        if(btn){ btn.setAttribute('data-product-id', productId); btn.setAttribute('data-color', colorValue); }
        var bag = card.querySelector('.icon_bag_apolo');
        if(bag){ bag.setAttribute('product_id', productId); if(sectionId) bag.setAttribute('data-section-id', sectionId); bag.setAttribute('data-selected-color', colorValue); }
        var img = card.querySelector('.card__media img') || card.querySelector('img');
        var fimg = firstAvail.featured_image && (firstAvail.featured_image.src || firstAvail.featured_image);
        if(img && fimg){ img.srcset = fimg; img.src = fimg; }
        // precio de la card
        var priceBox = document.querySelector('.price_' + productId + '_' + sectionId);
        if(priceBox){
          var saleEl = priceBox.querySelector('.price-item--sale') || priceBox.querySelector('.price-item');
          var regEl = priceBox.querySelector('.apolo_regular') || priceBox.querySelector('.price-item--regular');
          if(saleEl) saleEl.textContent = formatSoles(firstAvail.price);
          if(regEl){
            if(firstAvail.compare_at_price && firstAvail.compare_at_price > firstAvail.price){ regEl.textContent = formatSoles(firstAvail.compare_at_price); regEl.style.display=''; }
            else regEl.style.display='none';
          }
        }
      });
      // popup móvil
      var mBox = document.querySelector('.options_movil_' + productId + '[data-mobile-options]') || document.querySelector('.options_movil_' + productId);
      if(mBox){
        var mList = mBox.querySelector('[data-mobile-list]');
        if(mList && sizes.length){
          mList.innerHTML = sizes.map(function(s){
            var vv = colorVars.find(function(v){ var o=v.options||[v.option1,v.option2,v.option3]; return o.includes(s); });
            var avail = vv && vv.available;
            return `<div role="option" ${avail?'':'disabled'} class="${avail?'':'disabled '}item" style="pointer-events: all;"><div data-variant-size="${s}" data-color="${colorValue}" data-section-id="${sectionId||''}" class="size-option small-p small-p--black" onclick="addToCart_movil(event, ${productId}, this.getAttribute('data-section-id'))">${s}</div><div class="divider"></div></div>`;
          }).join('');
        }
        mBox.setAttribute('data-selected-color', colorValue);
      }
    }
    function findVariantIdForSize(productId, sectionId, sizeValue, colorValue){
      // Intentar via JSON variants-data (nuevo, robusto)
      var jsonEl = null;
      if(sectionId){
        jsonEl = document.querySelector(`.variants-data[data-product-id="${productId}"][data-section-id="${sectionId}"]`);
      }
      if(!jsonEl) jsonEl = document.querySelector(`.variants-data[data-product-id="${productId}"]`);
      if(jsonEl){
        try{
          var variants = JSON.parse(jsonEl.textContent);
          // solo color, sin talla: primera disponible de ese color
          if(colorValue && !sizeValue){
            for(var i=0;i<variants.length;i++){
              var v = variants[i];
              if(!v.available) continue;
              var opts0 = v.options || [v.option1, v.option2, v.option3];
              if(opts0.includes(colorValue)) return v.id;
            }
          }
          // si hay color seleccionado (modelo nuevo Color+Talla), exigir ambas opciones
          if(colorValue && sizeValue){
            for(var i=0;i<variants.length;i++){
              var v = variants[i];
              if(!v.available) continue;
              var opts = v.options || [v.option1, v.option2, v.option3];
              if(opts.includes(sizeValue) && opts.includes(colorValue)) return v.id;
            }
            for(var i=0;i<variants.length;i++){
              var v = variants[i];
              var opts = v.options || [v.option1, v.option2, v.option3];
              if(opts.includes(sizeValue) && opts.includes(colorValue)) return v.id;
            }
          }
          // buscar variante disponible donde alguna option == sizeValue
          for(var i=0;i<variants.length;i++){
            var v = variants[i];
            if(!v.available) continue;
            if(v.options && v.options.includes(sizeValue)) return v.id;
            if(v.option1 === sizeValue || v.option2 === sizeValue || v.option3 === sizeValue) return v.id;
          }
          // fallback: primera con ese size aunque no disponible (para mostrar error)
          for(var i=0;i<variants.length;i++){
            var v = variants[i];
            if(v.options && v.options.includes(sizeValue)) return v.id;
          }
        }catch(e){ console.error("JSON variants parse error", e); }
      }
      // fallback legacy: spans variant_id_op
      var variantsDiv = document.querySelector(".variants_" + productId);
      // si hay section, intentar con id+section
      if(!variantsDiv && sectionId) variantsDiv = document.querySelector(`.variants_${productId}-${sectionId}`);
      if(!variantsDiv) return null;
      var variantNodes = variantsDiv.querySelectorAll(".variant_id_op");
      var found = null;
      variantNodes.forEach((node) => {
        var id = node.getAttribute('data-id');
        var o1 = node.getAttribute('data-option1');
        var o2 = node.getAttribute('data-option2');
        var o3 = node.getAttribute('data-option3');
        var title = node.textContent.trim();
        // legacy: id-option1
        if(!id){
          var parts = title.split("-").map(s=>s.trim());
          id = parts[0];
          o1 = parts[1];
        }
        if(o1 === sizeValue || o2 === sizeValue || o3 === sizeValue){
          if(!found) found = id;
        }
        if(title.includes(sizeValue) && !found) found = id;
      });
      return found ? parseInt(found,10) : null;
    }

    async function addToCart(productId, sectionId, buttonEl) {
        showLoadingOverlay();
        // buscar card scope para selected
        var card = buttonEl ? (buttonEl.closest('.card-wrapper') || buttonEl.closest('.apolo_card') || document.querySelector(`.apolo_${productId}_${sectionId}`) || document) : document;
        var selectedSizeButton = card ? card.querySelector(".btn_apolo.selected") : body.querySelector(".btn_apolo.selected");
        // si no hay seleccionado en card, buscar global como fallback
        if(!selectedSizeButton && card !== document) selectedSizeButton = card.querySelector(".btn_apolo.selected");
        if(!selectedSizeButton){
          // fallback: producto sin Talla (solo Color) -> agregar primera variante disponible del color seleccionado
          var noSizeButtons = !(card && card.querySelector && card.querySelector('.btn_apolo'));
          if(noSizeButtons){
            var fallbackColor = (buttonEl && buttonEl.getAttribute('data-color')) || (card && card.querySelector && (function(){ var c = card.querySelector('.container_options'); return c && c.dataset ? c.dataset.selectedColor : null; })()) || null;
            var fallbackId = findVariantIdForSize(productId, sectionId, null, fallbackColor);
            // findVariantIdForSize with null size: buscar primera disponible de ese color
            if(!fallbackId && fallbackColor){
              try{
                var jel = sectionId ? document.querySelector(`.variants-data[data-product-id="${productId}"][data-section-id="${sectionId}"]`) : null;
                if(!jel) jel = document.querySelector(`.variants-data[data-product-id="${productId}"]`);
                if(jel){
                  var vs = JSON.parse(jel.textContent);
                  for(var k=0;k<vs.length;k++){ var vv=vs[k]; if(!vv.available) continue; var oo=vv.options||[vv.option1,vv.option2,vv.option3]; if(oo.includes(fallbackColor)){ fallbackId=vv.id; break; } }
                }
              }catch(e){}
            }
            if(fallbackId){
              try{
                var r0 = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:fallbackId,quantity:1})});
                if(!r0.ok){ var d0=await r0.json(); throw new Error(d0.description||'Failed'); }
              }catch(err){ console.error('Error:',err); hideLoadingOverlay(); alert(err.message||'No se pudo agregar'); return; }
              finally{ try{ await updateCartDrawer(); }catch(e){} hideLoadingOverlay(); }
              return;
            }
          }
          hideLoadingOverlay();
          // feedback visual: resaltar que debe elegir talla
          if(card && card.querySelector){
            var firstBtn = card.querySelector('.btn_apolo:not(.sold_out)');
            if(firstBtn) {
              firstBtn.style.outline = '2px solid #000';
              setTimeout(()=> firstBtn.style.outline='', 1000);
            }
          }
          return;
        }
        if(selectedSizeButton.classList.contains('sold_out') || selectedSizeButton.hasAttribute('disabled')){
          hideLoadingOverlay();
          return;
        }
        var variantSize = selectedSizeButton.getAttribute("data-variant-size");
        var variantColor = selectedSizeButton.getAttribute("data-color") || (card && card.querySelector ? (function(){ var c = card.querySelector('.container_options'); if(c && c.dataset && c.dataset.selectedColor) return c.dataset.selectedColor; var b = card.querySelector('.btn_add_to_cart'); if(b) return b.getAttribute('data-color'); return null; })() : null);
        if(!variantColor && buttonEl) variantColor = buttonEl.getAttribute('data-color');
        var variantId = findVariantIdForSize(productId, sectionId, variantSize, variantColor);
        if(!variantId){
          console.error('No se encontró variante para talla:', variantSize);
          hideLoadingOverlay();
          return;
        }
        var quantity = 1;
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: quantity }),
            });
            if (!response.ok) {
              var data = await response.json();
              throw new Error(data.description || 'Failed to add to cart');
            }
        } catch (error) {
            console.error('Error:', error);
            hideLoadingOverlay();
            alert(error.message || 'No se pudo agregar al carrito');
            return;
        } finally {
             try{ await updateCartDrawer(); }catch(e){}
            hideLoadingOverlay();
        }
    }
    function showLoadingOverlay() {
        let overlay = document.querySelector('#loadingOverlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'loadingOverlay';
            overlay.style.position = 'fixed';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
            overlay.style.zIndex = '9999';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';
            overlay.style.color = 'white';
            overlay.style.fontSize = '20px';
            overlay.style.fontWeight = 'bold';
            overlay.style.textAlign = 'center';
            overlay.innerHTML = 'Cargando...';
            document.body.appendChild(overlay);
        } else {
            overlay.style.display = 'flex';
        }
    }
    function hideLoadingOverlay() {
        const overlay = document.querySelector('#loadingOverlay');
        if (overlay) overlay.style.display = 'none';
    }

    async function addToCart_movil(event, productId, sectionId) {
      event.stopPropagation();
      // si viene desde popup dinámico, el target es el div size-option
      var selectedEl = event.target.closest('[data-variant-size]') || event.target;
      var variantSize = selectedEl.getAttribute("data-variant-size");
      var variantColor = selectedEl.getAttribute ? selectedEl.getAttribute("data-color") : null;
      if(!variantColor){
        var popupBox = document.getElementById("popupContent");
        if(popupBox && popupBox.dataset && popupBox.dataset.selectedColor) variantColor = popupBox.dataset.selectedColor;
      }
      if(!variantSize) variantSize = selectedEl.textContent.trim();
      // cerrar popup antes de agregar
      try{ closeDialog(); }catch(e){}
      showLoadingOverlay();
      var variantId = findVariantIdForSize(productId, sectionId, variantSize, variantColor);
      if (!variantId) {
        console.error("No se encontró variante para:", variantSize);
        hideLoadingOverlay();
        return;
      }
       var quantity = 1;
       try {
                const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: variantId, quantity: quantity }),
              });
              if (!response.ok) {
                var data = await response.json();
                throw new Error(data.description || 'Failed to add to cart');
              }
            } catch (error) {
              console.error('Error:', error);
              hideLoadingOverlay();
              alert(error.message || 'No se pudo agregar');
              return;
        } finally {
          try{ await updateCartDrawer(); }catch(e){}
          hideLoadingOverlay();
        }
}
    async function updateCartDrawer() {
      try {
        const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
        if (!response.ok) throw new Error('Failed to fetch cart drawer');
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newCartDrawerContent = html.querySelector('cart-drawer');
        if (newCartDrawerContent) {
          const existingCartDrawer = document.querySelector('cart-drawer');
          if (existingCartDrawer) {
            existingCartDrawer.replaceWith(newCartDrawerContent);
          } else {
            document.body.appendChild(newCartDrawerContent);
          }
        }
        openCartDrawer();
      } catch (error) {
        console.error('Error updating cart drawer:', error);
        // fallback recargar
        // window.location.href = routes.cart_url;
      }
    }
    function openCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        // asegurar que el drawer esté visible si usa details
        var details = cartDrawer.querySelector('details');
        if(details && !details.hasAttribute('open')) details.setAttribute('open','');
      }
 }
  
